/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `ko` - 한국어
 * `en` - English
 * `ja` - 日本語
 * `zh` - 中文(简体)
 * `zh-Hant` - 中文(繁體, 대만/홍콩)
 * `th` - ไทย
 * `pt-BR` - Português (BR)
 * `es` - Español
 * `id` - Bahasa Indonesia
 * `vi` - Tiếng Việt
 * `fil` - Filipino
 * `ms` - Bahasa Melayu
 */
export type UsedLanguageEnum =
  (typeof UsedLanguageEnum)[keyof typeof UsedLanguageEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedLanguageEnum = {
  ko: "ko",
  en: "en",
  ja: "ja",
  zh: "zh",
  "zh-Hant": "zh-Hant",
  th: "th",
  "pt-BR": "pt-BR",
  es: "es",
  id: "id",
  vi: "vi",
  fil: "fil",
  ms: "ms",
} as const;
